import isElement from 'lodash/isElement';
import get from 'lodash/get';

const WINDOW = typeof window !== 'undefined' ? window : null;
(WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.MutationObserver) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.WebKitMutationObserver) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.MozMutationObserver) || null;
const requestAF = ((WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.requestAnimationFrame) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.webkitRequestAnimationFrame) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.mozRequestAnimationFrame) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.msRequestAnimationFrame) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.oRequestAnimationFrame) || (
// Fallback, but not a true polyfill
// Only needed for Opera Mini
cb => setTimeout(cb, 16))).bind(WINDOW);
// eslint-disable-next-line no-unsafe-optional-chaining
const cancelAF = ((WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.cancelAnimationFrame) || (WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW.mozCancelAnimationFrame)).bind(WINDOW);
// Cause/wait-for an element to reflow its content (adjusting its height/width)
const reflow = el => {
  // Requesting an elements offsetHeight will trigger a reflow of the element content
  return get(el, ['offsetHeight'], null);
};
// Add a class to an element
const addClass = (el, className) => {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  if (className && isElement(el) && el.classList) {
    el.classList.add(className);
  }
};
// Remove a class from an element
const removeClass = (el, className) => {
  // We are checking for `el.classList` existence here since IE 11
  // returns `undefined` for some elements (e.g. SVG elements)
  if (className && isElement(el) && el.classList) el.classList.remove(className);
};
// Set an style property on an element
const setStyle = (el, prop, value) => {
  if (prop && isElement(el)) {
    el.style[prop] = value;
  }
};
// Remove an style property from an element
const removeStyle = (el, prop) => {
  if (prop && isElement(el)) {
    el.style[prop] = '';
  }
};
// Return the Bounding Client Rect of an element
const getBCR = el => isElement(el) ? el.getBoundingClientRect() : null;
// Get computed style object for an element
const getCS = el => get(WINDOW, 'getComputedStyle', null) && isElement(el) ? getComputedStyle(el) : {};
const getMaxZIndex = element => {
  let maxZIndex = 0;
  while (element) {
    const cs = getCS(element);
    const zIndex = cs.zIndex;
    if (zIndex !== 'auto') {
      maxZIndex = +zIndex > maxZIndex ? +zIndex : maxZIndex;
    }
    element = element.parentElement;
  }
  return maxZIndex;
};

export { reflow as a, removeStyle as b, cancelAF as c, getCS as d, getMaxZIndex as e, addClass as f, getBCR as g, removeClass as h, requestAF as r, setStyle as s };
